// Sistema de marca FELVORA Compliance
import { cn } from "@/lib/utils";

const SAGE = "#A8B89F";

// Isotipo FELVORA: el punto de acento (sage/marfil según tono)
export function VoraMark({ className, dotColor, stroke, style }) {
  const color = dotColor || stroke || "currentColor";
  return (
    <svg viewBox="0 0 100 100" className={className} style={style} fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="50" cy="50" r="38" fill={color} />
    </svg>
  );
}

/**
 * variant: 'stacked' | 'horizontal' | 'wordmark' | 'compact'
 * tone: 'light' (sobre fondo oscuro) | 'dark' (sobre fondo claro)
 * Nota: el nombre del componente se conserva por compatibilidad de imports; la marca renderizada es FELVORA.
 */
export function VoraLogo({ variant = "stacked", tone = "light", className, withFelvora = true, mark = true }) {
  const isLight = tone === "light";
  const main = isLight ? "text-[#F7F7F2]" : "text-[#1B2E1F]";
  const sage = "text-[#7E9070]";

  if (variant === "compact") {
    return (
      <div className={cn("flex items-start gap-2", className)}>
        {mark && <VoraMark className={cn("mt-1 h-2.5 w-2.5", main)} />}
        <div className="leading-none">
          <span className={cn("brand-font text-base font-light", main)} style={{ letterSpacing: "0.26em" }}>FELVORA</span>
          <p className={cn("brand-font mt-1 text-[9px] font-light uppercase", sage)} style={{ letterSpacing: "0.4em" }}>Compliance</p>
        </div>
      </div>
    );
  }

  if (variant === "wordmark") {
    return (
      <div className={cn("flex flex-col", className)}>
        <span className={cn("brand-font text-2xl font-light leading-none", main)} style={{ letterSpacing: "0.3em" }}>FELVORA</span>
        <span className={cn("brand-font mt-1.5 text-[10px] font-light uppercase", sage)} style={{ letterSpacing: "0.5em" }}>Compliance</span>
      </div>
    );
  }

  if (variant === "horizontal") {
    return (
      <div className={cn("flex items-start gap-3", className)}>
        {mark && <VoraMark className={cn("mt-1.5 h-3 w-3", main)} />}
        <div className="flex flex-col leading-none">
          <span className={cn("brand-font text-xl font-light", main)} style={{ letterSpacing: "0.3em" }}>FELVORA</span>
          <span className={cn("brand-font mt-1 text-[9px] font-light uppercase", sage)} style={{ letterSpacing: "0.46em" }}>Compliance</span>
        </div>
      </div>
    );
  }

  // stacked / centrada
  return (
    <div className={cn("flex flex-col items-center text-center", className)}>
      {mark && <VoraMark className={cn("mb-3 h-4 w-4", main)} />}
      <span className={cn("brand-font text-3xl font-light", main)} style={{ letterSpacing: "0.3em", paddingLeft: "0.3em" }}>FELVORA</span>
      <span className={cn("brand-font mt-2 text-xs font-light uppercase", sage)} style={{ letterSpacing: "0.55em", paddingLeft: "0.55em" }}>Compliance</span>
    </div>
  );
}
